import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

const { colors, breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { xs } = breakpoints.BreakpointNames;
const { fontSize } = typographyStyles;

const borderStyles = `1px solid ${colors.ui.neutral[100]}`;

export const rowCss = {
  display: "flex",
  flexWrap: "wrap",
  margin: "0",
  padding: "8px 0",
  width: "100%",

  "&:first-of-type": {
    marginTop: 0,
    paddingTop: 0,
  },

  "&:last-child": {
    marginBottom: 0,
    paddingBottom: 0,
  },

  "&:not(:last-child)": {
    borderBottom: borderStyles,
  },
  // Additional mobile styling that moves "Published" to its own row
  [mediaQuery.upTo(xs)]: {
    "> div:nth-of-type(2)": {
      borderRight: 0,
    },
    "> div:nth-of-type(3)": {
      padding: "8px 0 0",
      marginTop: "8px",
      borderTop: borderStyles,
      width: "100%",
    },
  },
};

export const itemCss = {
  padding: "0 16px",

  "&:first-of-type": {
    paddingLeft: 0,
  },

  "&:not(:last-child)": {
    borderRight: borderStyles,
  },
};

export const labelCss = {
  textTransform: "uppercase",
  fontSize: "0.625rem",
  color: colors.ui.neutral[400],
  marginRight: "4px",
  letterSpacing: "1px",
};

export const valueCss = {
  ...fontSize.textM,
  color: colors.ui.neutral[600],
};
